export default __webpack_public_path__ + "static/media/percent.02548975.svg";